module.exports = __webpack_public_path__ + "static/media/phantom.95250ffd.png";